export default {
  LabelDisplayedRowsNoMore: '#{from}-#{to} of #{numOfRows}',
  LabelDisplayedRowsMore: '#{from}-#{to} of more than #{numOfRows}',
  ShowingAmountOfItems: `Showing %(length)i of %(total)i`,
  NoResult: 'No results found. Please adjust your filter criteria.',
  RowsPerPage: 'Rows per page',
};
